// extracted by mini-css-extract-plugin
module.exports = {"Duration":"member-operations__Duration__Duration","Duration__icon":"member-operations__Duration__Duration__icon"};